import { Component, OnInit } from '@angular/core';
import { AlertController, MenuController, ModalController, NavController } from '@ionic/angular';
import { Header } from 'src/app/interfaces/book.interface';
import { AppUsabilidadService } from 'src/app/services/app-usabilidad.service';
import { AuthService } from 'src/app/services/auth.service';
import { RedatwaterService } from 'src/app/services/redatwater.service';
import { TextSpeechService } from 'src/app/services/text-speech.service';

@Component({
  selector: 'app-app-usabilidad',
  templateUrl: './app-usabilidad.component.html',
  styleUrls: ['./app-usabilidad.component.scss'],
})
export class AppUsabilidadComponent implements OnInit {

  channelSistema: any = null;
  channelApp: any = null;

  idiomaSeleccionado: string = null;
  selectedLanguage: string;
  itemsIdiomaApp: any = [];
  itemsIdioma: any = [];
  idiomaPagina = 'APP_USABILIDAD';
  authDispositivo: any = null;

  aquaBot: any = {
    guia_referencia: '',
    msg: '',
    estado: ''
  };

  header: Header = {
    nivel: 2,
    pagina: '',
    titulo: '',
  };

  aquahabiente: any = {
    codigo: null,
    clave: null,
    encriptado: 1
  }

  authAdmin: any = null;


  onHelpVoz: boolean = false;
  onHelpAudio: boolean = false;
  onHelpVozText: string = 'off';
  onHelpAudioText: string = 'off';

  constructor(
    private appUsabilidad: AppUsabilidadService,
    private menu: MenuController,
    private redatwater: RedatwaterService,
    private auth: AuthService,
    private navCtrl: NavController,
    private modalController: ModalController,
    private alertCtr: AlertController,
    private textSpeech: TextSpeechService
    ) {
    console.log('App: Ajustes App.');
    this.header.pagina = '/';
    this.header.titulo = 'AJUSTES';
    // INIT
    this.increaseFontSize();
    this.decreaseFontSize();
  }

  ngOnInit() {
    this.consultarParametrosApp();
    this.auth.getAuthDispositivoObservable().subscribe(async (getDispositivo: any) => {
      console.log('Dispositivo Auth ->', getDispositivo);
      if (getDispositivo) {

        //console.log('Parametros de idioma App -> ', this.itemsIdiomaApp);
        //console.log('Parametros de idioma -> ', this.itemsIdioma);
        //console.log('Test 1 -> ', this.itemsIdiomaApp.app_loading);
        this.authDispositivo = getDispositivo;
        this.redatwater.getDataSistema(this.authDispositivo.sistema_id).then((getData: any) => {
          console.log('Seguimiento -> Datos de sistema: ', getData);
          if (getData) {
            if (getData?.channel_app[0].channel_sistema) {
              this.channelApp = getData.channel_app;
              this.channelSistema = getData?.channel_app[0].channel_sistema;
            } else {
              console.log('Seguimiento de errores -> Datos de sistema:  ', getData);
            }
          } else {
            console.log('Seguimiento de errores -> Datos de sistema:  ', getData);
          }
        }).catch((err: any) => {
          console.log('Seguimiento de errores -> ', err);
        });

      }
    });
  }

  ngAfterViewInit() {
    this.appUsabilidad.establecerFontSize();
  }


  /* Nav Panel de sistema */
  navPanelSistema() {
    this.loginPanelSistema();
  }


  async loginPanelSistema() {
    if (this.channelSistema?.id) {
      console.log('Seguimiento -> Iniciar sesion: Panel sistema');
      const alert = await this.alertCtr.create({
        cssClass: 'my-custom-class',
        header: 'RED AT-WATER',
        message: '<span class="text-success">Cuenta Aquacliente:</span> ',
        inputs: [
          {
            name: 'codigo',
            type: 'number',
            placeholder: 'Código de cuenta:'
          },
          {
            name: 'clave',
            type: 'password',
            placeholder: 'Clave de seguridad:'
          }
        ],
        buttons: [
          {
            text: 'Cerrar ventana',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Cerrar!');
            }
          }, {
            text: 'Aceptar',
            handler: (data) => {
              console.log('Ok!');

              if (data.codigo !== '' && data.clave !== '') {

                if (data.clave.length === 4) {

                  console.log('Acceso Clave OK');
                  this.aquahabiente.codigo = data.codigo;
                  this.aquahabiente.clave = data.clave;
                  this.verificarAcceso();

                } else {
                  console.log('¡Oops! Clave: ', data.clave);
                }

              } else {
                console.log('Campos obligatorios. ', data);
                this.loginPanelSistema();
              }

            }
          }
        ]
      });
      await alert.present();
    } else {
      console.log('Seguimiento de errores -> Parametros incompletos para inicio de sesion ', this.channelSistema);
    }
  }

  async verificarAcceso() {
    if (this.authDispositivo.id && (this.aquahabiente.codigo && this.aquahabiente.clave)) {
      this.redatwater.getCuentaAdminAquahabiente(this.authDispositivo.id, this.aquahabiente).then((getData: any) => {
        if (getData) {
          console.log('Seguimiento -> Cuenta ADMIN: ', getData);
          if (getData.channel_app[0]?.aquahabiente_admin) {
            this.authAdmin = getData.channel_app[0].aquahabiente_admin;
            console.log('Admin AQUAHABIENTE: ', getData.channel_app[0].aquahabiente_admin);
            this.auth.setAuthTokenAdmin(this.authAdmin).then((authAdmin: any) => {
              if (authAdmin) {
                console.log('Seguimiento -> Sesion establecida!');
                this.cerrarVentana();
                this.navCtrl?.navigateRoot(['/app-edit']);
              } else {
                console.log('Seguimiento de errores -> ', authAdmin);
              }
            }).catch((err: any) => {
              console.log('Seguimiento de errores -> ', err);
            });

          } else {
            console.log('Seguimiento de errores -> ', getData);
          }
        } else {
          console.log('Seguimiento de errores -> ', getData);
        }
      }).catch((err: any) => {
        console.log('Seguimiento de errores -> ', err);
      });
    } else {
      console.log('Seguimiento de errores -> ', this.authDispositivo, this.aquahabiente);
      this.loginPanelSistema();
    }
  }



  consultarParametrosApp() {
    this.appUsabilidad.getAppUsabilidad().then((getApp: any) => {

      this.appUsabilidad.establecerFontSize();

      if (getApp?.value) {
        this.establecerParametros(JSON.parse(getApp.value));
        
      } else {
        console.log('Seguimiento de errores -> ', getApp);
      }
    }).catch((error: any) => {
      console.log('Seguimiento de errores -> ', error);
    });
  }

  async establecerParametros(parametros: any) {
    if (parametros) {

      console.log('Seguimiento -> Estableciendo parametros de App Usabilidad.');

      this.appUsabilidad.establecerFontSize();

      if (parametros?.fontsize) {
        
        this.appUsabilidad.setFontSize(parametros.fontsize);
      }

      if (parametros?.help_audio_text === 'on') {
        this.onHelpAudio = true;
      } else {
        this.onHelpAudio = false;
      }

      this.establecerHelpAudio(this.onHelpAudio);

      if (parametros?.help_voz_text === 'on') {
        this.onHelpVoz = true;
      } else {
        this.onHelpVoz = false;
      }
      this.establecerHelpVoz(this.onHelpVoz);
    }
  }

  increaseFontSize() {
    this.appUsabilidad.increaseFontSize();
    
  }

  decreaseFontSize() {
    this.appUsabilidad.decreaseFontSize();
    
  }

  guardarConfiguracion() {
    let parametrosData: any = {
      fontsize: this.appUsabilidad.fontSize,
      help_audio: this.onHelpAudioText,
      help_voz: this.onHelpVozText
    }
    console.log('Parametros -> Guardar: ', parametrosData);
    this.appUsabilidad.saveAppUsabilidad(parametrosData);
    this.consultarParametrosApp();
  }

  establecerHelpVoz(opcion: any) {
    if (opcion) {
      this.onHelpVoz = true;
      this.onHelpVozText = 'on';
      this.textSpeech.hablar('Puedo hablar.');
    } else {
      this.onHelpVoz = false;
      this.onHelpVozText = 'off';
    }
  }

  establecerHelpAudio(opcion: any) {
    if (opcion) {
      this.onHelpAudio = true;
      this.onHelpAudioText = 'on';
      this.textSpeech.hablar('Puedo escuchar y hablar.');
    } else {
      this.onHelpAudio = false;
      this.onHelpAudioText = 'off';
    }
  }
  

  cerrarVentana() {
    console.log('Cerrar ventana!');
    this.modalController.dismiss();
  }

}
